export default {
  0: [{ title: "테스트페이지" }],
  53: [{ title: "산업재해발생" }, { title: "사고보고" }, { title: "사고조사 보고서" }],
  54: [{ title: "산업재해발생" }, { title: "사고보고" }, { title: "사고경위서" }],
  55: [{ title: "산업재해발생" }, { title: "사고보고" }, { title: "목격자 진술서" }],
  56: [{ title: "산업재해발생" }, { title: "실험실 안전사고 보고" }],
  57: [{ title: "산업재해발생" }, { title: "산업재해조사표" }],
  58: [{ title: "위원회 및 협의체" }, { title: "본사" }, { title: "산업안전보건위원회" }],
  59: [{ title: "위원회 및 협의체" }, { title: "본사" }, { title: "안전경영위원회" }],
  60: [{ title: "위원회 및 협의체" }, { title: "본사" }, { title: "안전근로협의체" }],
  61: [{ title: "위원회 및 협의체" }, { title: "본부" }, { title: "안전보건협의체" }],
  62: [{ title: "아차사고" }, { title: "아차사고관리" }, { title: "아차사고 사례 카드" }],
  63: [{ title: "아차사고" }, { title: "아차사고관리" }, { title: "아차사고 사례 개선 확인 카드" }],
  64: [{ title: "안전점검" }, { title: "본사" }, { title: "실험실 일상 점검표" }],
  65: [{ title: "안전점검" }, { title: "본사" }, { title: "실험실 정기 점검표" }],
  66: [{ title: "안전점검" }, { title: "본사" }, { title: "TAC 안전관리 점검표" }],
  67: [{ title: "안전점검" }, { title: "본사" }, { title: "밀폐공간 작업프로그램 평가표" }],
  68: [{ title: "안전점검" }, { title: "본사" }, { title: "밀폐공간 작업 전 체크리스트" }],
  69: [{ title: "안전점검" }, { title: "본사" }, { title: "고압가스 충전실 안전점검표" }],
  70: [{ title: "안전점검" }, { title: "남해본부" }, { title: "한수단 2호 안전점검표" }],
  71: [{ title: "안전점검" }, { title: "공통" }, { title: "잠수 운용 계획서" }],
  72: [{ title: "안전점검" }, { title: "공통" }, { title: "잠수작업 전 안전점검표" }],
  73: [{ title: "안전점검" }, { title: "공통" }, { title: "잠수 운용 결과서" }],
  74: [{ title: "안전점검" }, { title: "공통" }, { title: "중량물·운반기계 안전점검표" }],
  75: [{ title: "안전점검" }, { title: "공통" }, { title: "작업장 안전점검표" }],
  76: [{ title: "부적합 및 시정조치" }, { title: "부적합 및 시정조치" }, { title: "안전" }],
  77: [{ title: "부적합 및 시정조치" }, { title: "부적합 및 시정조치" }, { title: "보건" }],
  78: [{ title: "작업중지제" }, { title: "작업중지 보고서" }, { title: "공단임직원" }],
  79: [{ title: "작업중지제" }, { title: "작업중지 보고서" }, { title: "수급업체 근로자" }],
  80: [{ title: "작업중지제" }, { title: "작업중지 조치결과서" }, { title: "공단임직원" }],
  81: [{ title: "작업중지제" }, { title: "작업중지 조치결과서" }, { title: "수급업체 근로자" }],
  82: [{ title: "위험성평가" }, { title: "위험성평가" }, { title: "정기 위험성평가" }],
  83: [{ title: "위험성평가" }, { title: "위험성평가" }, { title: "수시 위험성평가" }],
  84: [{ title: "안전작업허가" }, { title: "안전작업허가" }, { title: "작업수행부서" }],
  85: [{ title: "안전작업허가" }, { title: "안전작업허가" }, { title: "수급업체" }],
  86: [{ title: "안전·보건예산 현황" }, { title: "안전·보건예산 현황" }],
  87: [{ title: "작업중지제" }, { title: "작업중지 보고서" }, { title: "기타" }],
  88: [{ title: "작업중지제" }, { title: "작업중지 조치결과서" }, { title: "기타" }],
  89: [{ title: "사업장 개요" }, { title: "사업장 정보" }],

  100: [{ title: "안전·보건 경영방침" }, { title: "작업장 합동점검" }],
  101: [{ title: "사업장 등록" }, { title: "안전·보건 경영방침" }],
  2.101: [{ title: "안전·보건관리 현황" }, { title: "안전·보건 경영방침" }],
  102: [{ title: "안전·보건관리 현황" }, { title: "수행평가" }],
  103: [{ title: "사업장/시설물 개요" }, { title: "직영사업장" }],
  104: [{ title: "안전·보건조직체계" }, { title: "소속부서 및 담당업체 정보" }],
  105: [{ title: "시스템 계약 현황" }, { title: "수급업체 등록 요청" }],
  106: [{ title: "안전·보건 예산" }, { title: "안전·보건 예산(A형)" }],
  107: [{ title: "안전·보건 교육" }, { title: "안전·보건 교육" }],
  108: [{ title: "유해·위험요인 관리" }, { title: "유해·위험요인 조사표" }],
  109: [{ title: "안전·보건 경영방침" }, { title: "사업장 안전·보건 경영방침" }],
  110: [{ title: "안전·보건 점검" }, { title: "도로 보수" }],
  111: [{ title: "사업장/시설물 개요" }, { title: "사업장(안전보건 예산(C형))" }],
  112: [{ title: "안전·보건 점검" }, { title: "건설현장 일반관리" }],
  113: [{ title: "안전·보건 점검" }, { title: "수영장" }],
  114: [{ title: "시설물 안전 점검" }, { title: "시설물 점검" }],
  115: [{ title: "사업장/시설물 개요" }, { title: "시설물 관리" }],
  116: [{ title: "재해발생 대비 대책" }, { title: "(재해발생) 산업재해 발생 시 보고 절차 안내" }],
  117: [{ title: "재해발생보고" }, { title: "산업재해조사표" }],

  118: [{ title: "시스템 계약 현황" }, { title: "계약 정보" }],

  119: [{ title: "안전·보건조직체계" }, { title: "안전보건관리 책임자 지정 외" } /*, {title: '안전보건총괄책임자 선임'}*/],
  120: [{ title: "안전·보건조직체계" }, { title: "안전보건관리 책임자 지정 외" } /*, {title: '중대재해예방팀 선임'}*/],
  121: [{ title: "안전·보건조직체계" }, { title: "안전보건조정자 선임" }],
  122: [{ title: "안전·보건조직체계" }, { title: "안전보건관리 책임자 지정 외" } /*, {title: '안전보건관리자 및 산업보건의 선임'}*/],
  123: [{ title: "안전·보건조직체계" }, { title: "안전보건관리 책임자 지정 외" } /*, {title: '안전보건관리자 및 산업보건의(건설업) 선임'}*/],
  124: [{ title: "안전·보건조직체계" }, { title: "안전보건담당자 선임" }],
  125: [{ title: "안전·보건조직체계" }, { title: "안전보건관리 책임자 지정 외" } /*, {title: '관리감독자 선임'}*/],
  126: [{ title: "안전·보건조직체계" }, { title: "안전·보건 조직 체계도" }],

  127: [{ title: "안전·보건관리 현황" }, { title: "수행평가" }],
  128: [{ title: "안전·보건관리 현황" }, { title: "수행평가" }],
  129: [{ title: "안전·보건관리 현황" }, { title: "종사자 참여 평가" }],
  130: [{ title: "안전·보건관리 현황" }, { title: "수급업체 수행평가" }],
  131: [{ title: "안전·보건관리 현황" }, { title: "수시 점검표" }],

  132: [{ title: "안전·보건 교육" }, { title: "교육 모니터링" }],
  133: [{ title: "안전·보건관리 현황" }, { title: "월별 보고" }],
  134: [{ title: "안전·보건관리 현황" }, { title: "반기별 보고" }],

  135: [{ title: "안전·보건조직체계" }, { title: "소속부서 및 담당업체 정보" }],
  136: [{ title: "안전·보건조직체계" }, { title: "안전보건 점검 인력" }],
  137: [{ title: "안전·보건관리 현황" }, { title: "안전·보건 점검 계획" }],
  138: [{ title: "안전·보건조직체계" }, { title: "비상 연락/지원 체계도" }],
  139: [{ title: "안전·보건조직체계" }, { title: "유관기관 비상연락망" }],
  140: [{ title: "안전·보건조직체계" }, { title: "안전·보건관리체계 구축 현황(중대산업재해)" }],
  141: [{ title: "안전·보건조직체계" }, { title: "안전보건 관련 인력" }],
  142: [{ title: "안전·보건조직체계" }, { title: "종사자 정보" }],

  143: [{ title: "안전·보건관리 현황" }, { title: "도급전 정보 제공" }],
  144: [{ title: "안전·보건관리 현황" }, { title: "안전보건대장 작성" }],
  145: [{ title: "안전·보건관리 현황" }, { title: "안전보건대장 작성" }],
  146: [{ title: "안전·보건관리 현황" }, { title: "안전보건대장 작성" }],
  147: [{ title: "안전·보건관리 현황" }, { title: "설계변경 요청" }],
  148: [{ title: "안전·보건관리 현황" }, { title: "건설공사 기간 연장" }],
  149: [{ title: "안전·보건관리 현황" }, { title: "수급인 산재예방 평가" }],
  150: [{ title: "안전·보건관리 현황" }, { title: "안전·보건 확보 의무" }],
  151: [{ title: "위험성평가" }, { title: "위험성평가협의회" }],
  152: [{ title: "안전·보건관리 현황" }, { title: "산업안전보건위원회" }],
  153: [{ title: "안전·보건관리 현황" }, { title: "노사협의체" }],

  154: [{ title: "안전·보건 예산" }, { title: "안전보건 예산(B형)" }],
  155: [{ title: "안전·보건 예산" }, { title: "안전보건 예산(C형)" }],

  156: [{ title: "유해·위험요인 관리" }, { title: "유해·위험요인 조사표" }],
  157: [{ title: "유해·위험요인 관리" }, { title: "유해·위험요인 조사표" }],
  158: [{ title: "유해·위험요인 관리" }, { title: "유해·위험요인 조사표" }],
  159: [{ title: "유해·위험요인 관리" }, { title: "유해·위험요인 조사표" }],
  160: [{ title: "유해·위험요인 관리" }, { title: "유해·위험요인 점검(개선)사항 요청" }],

  161: [{ title: "위험성평가" }, { title: "정기 위험성평가" }],
  162: [{ title: "위험성평가" }, { title: "수시 위험성평가" }],

  163: [{ title: "안전·보건 점검" }, { title: "일일안전보건점검일지" }],
  164: [{ title: "안전·보건 점검" }, { title: "요양보호사" }],
  165: [{ title: "안전·보건 점검" }, { title: "종사자 및 주차시설" }],
  166: [{ title: "안전·보건 점검" }, { title: "냉온수기 및 보일러 설비" }],
  167: [{ title: "안전·보건 점검" }, { title: "행사자 동선 및 관계자" }],
  168: [{ title: "안전·보건 점검" }, { title: "시설물 관리(공통)" }],
  169: [{ title: "안전·보건 점검" }, { title: "시설물 내부" }],

  170: [{ title: "안전·보건 점검" }, { title: "시설물 외부" }],
  171: [{ title: "안전·보건 점검" }, { title: "부대 시설" }],
  172: [{ title: "안전·보건 점검" }, { title: "비상설비" }],
  173: [{ title: "안전·보건 점검" }, { title: "소방용수 탱크" }],
  174: [{ title: "안전·보건 점검" }, { title: "소방 및 신호기" }],
  175: [{ title: "안전·보건 점검" }, { title: "주차시설" }],
  176: [{ title: "안전·보건 점검" }, { title: "기둥, 벽, 보, 천장" }],
  177: [{ title: "안전·보건 점검" }, { title: "전기시설" }],
  178: [{ title: "안전·보건 점검" }, { title: "전기 외함" }],
  179: [{ title: "안전·보건 점검" }, { title: "실외기 및 완강기" }],
  180: [{ title: "안전·보건 점검" }, { title: "가지치기" }],
  181: [{ title: "안전·보건 점검" }, { title: "진드기 및 질병예방" }],
  182: [{ title: "안전·보건 점검" }, { title: "산불예방감시" }],
  183: [{ title: "안전·보건 점검" }, { title: "풀베기" }],
  184: [{ title: "안전·보건 점검" }, { title: "산불진화작업" }],
  185: [{ title: "안전·보건 점검" }, { title: "청원경찰" }],
  186: [{ title: "안전·보건 점검" }, { title: "청소차량 및 환경미화원" }],
  187: [{ title: "안전·보건 점검" }, { title: "청소차량" }],
  188: [{ title: "안전·보건 점검" }, { title: "근로자 건강관리(공통)" }],
  189: [{ title: "안전·보건 점검" }, { title: "밀폐공간 작업" }],
  190: [{ title: "안전·보건 점검" }, { title: "유해화학물질 작업" }],
  191: [{ title: "안전·보건 점검" }, { title: "중량물 작업 시 안전점검" }],
  192: [{ title: "안전·보건 점검" }, { title: "작업장 바닥 작업" }],
  193: [{ title: "안전·보건 점검" }, { title: "외벽 청소 작업" }],
  194: [{ title: "안전·보건 점검" }, { title: "쓰레기 수거 작업" }],
  195: [{ title: "안전·보건 점검" }, { title: "화기·용접 작업" }],
  196: [{ title: "안전·보건 점검" }, { title: "급식 점검표" }],
  197: [{ title: "안전·보건 점검" }, { title: "응급조치" }],
  198: [{ title: "안전·보건 점검" }, { title: "계절성 업무에 따른 관리대책" }],
  199: [{ title: "안전·보건 점검" }, { title: "사다리 작업" }],
  200: [{ title: "안전·보건 점검" }, { title: "근골격계 질환" }],
  201: [{ title: "안전·보건 점검" }, { title: "안전보건교육" }],
  202: [{ title: "안전·보건 점검" }, { title: "위험작업별" }],
  203: [{ title: "안전·보건 점검" }, { title: "기계식 주차설비 작업" }],
  204: [{ title: "안전·보건 점검" }, { title: "청소(미화) 점검표" }],
  205: [{ title: "안전·보건 점검" }, { title: "복도 및 화장실청소" }],
  206: [{ title: "안전·보건 점검" }, { title: "승강기 작업" }],
  207: [{ title: "안전·보건 점검" }, { title: "전기작업" }],
  208: [{ title: "안전·보건 점검" }, { title: "위험대비 매뉴얼 대응조치 점검" }],
  209: [{ title: "안전·보건 점검" }, { title: "작업장 합동점검" }],
  210: [{ title: "안전·보건 점검" }, { title: "건설기계·장비별" }],
  211: [{ title: "안전·보건 점검" }, { title: "예초기 작업" }],
  212: [{ title: "안전·보건 점검" }, { title: "기계톱 작업" }],
  213: [{ title: "안전·보건 점검" }, { title: "곤돌라 작업" }],
  214: [{ title: "안전·보건 점검" }, { title: "지게차 안전점검표" }],

  215: [{ title: "안전·보건 점검" }, { title: "시설물 외부" }],

  216: [{ title: "안전·보건 점검" }, { title: "(건설현장) 사고유형별" }],
  217: [{ title: "안전·보건 점검" }, { title: "(건설현장) 사고유형별" }],
  218: [{ title: "안전·보건 점검" }, { title: "(건설현장) 사고유형별" }],
  219: [{ title: "안전·보건 점검" }, { title: "(건설현장) 건설기계·장비별" }],
  220: [{ title: "안전·보건 점검" }, { title: "(건설현장) 위험작업별" }],
  221: [{ title: "안전·보건 점검" }, { title: "(건설현장) 공정별" }],
  222: [{ title: "안전·보건 점검" }, { title: "헬스장 안전점검표" }],
  223: [{ title: "안전·보건 점검" }, { title: "실내체육관 안전점검표" }],
  224: [{ title: "안전·보건 점검" }, { title: "다목적실 안전점검표" }],
  225: [{ title: "안전·보건 점검" }, { title: "스트레칭실 안전점검표" }],
  226: [{ title: "안전·보건 점검" }, { title: "다목적 체육관 안전점검표" }],
  227: [{ title: "안전·보건 점검" }, { title: "샤워실 안전점검표" }],
  228: [{ title: "안전·보건 점검" }, { title: "탈의실 안전점검표" }],
  229: [{ title: "안전·보건 점검" }, { title: "보도 육교 안전점검표" }],
  230: [{ title: "안전·보건 점검" }, { title: "보도 육교 승강기 안전점검표" }],
  231: [{ title: "안전·보건 점검" }, { title: "제방 안전점검표" }],
  232: [{ title: "안전·보건 점검" }, { title: "방파제 안전점검표" }],
  233: [{ title: "안전·보건 점검" }, { title: "어린이집 안전점검표" }],

  234: [{ title: "시설물 안전 점검" }, { title: "시설물 진단" }],
  235: [{ title: "시설물 안전 점검" }, { title: "시설물 보수" }],
  236: [{ title: "시설물 안전 점검" }, { title: "시설물 보강" }],
  237: [{ title: "시설물 안전 점검" }, { title: "시설물 교체" }],

  238: [{ title: "재해발생 대비 대책" }, { title: "(재해발생) 비상조치 및 처리 절차 안내" }],
  239: [{ title: "재해발생 대비 대책" }, { title: "비상대피 훈련·교육·자체평가" }],
  240: [{ title: "재해발생 대비 대책" }, { title: "비상대피 훈련·교육·자체평가" }],
  241: [{ title: "재해발생 대비 대책" }, { title: "비상대피 훈련·교육·자체평가" }],
  242: [{ title: "재해발생 대비 대책" }, { title: "비상조치계획 수립" }],
  243: [{ title: "재해발생 대비 대책" }, { title: "관계수급인 안전보건 조치 확인 및 조정" }],

  244: [{ title: "재해발생 보고" }, { title: "중대재해 발생 보고" }],
  245: [{ title: "재해발생 보고" }, { title: "재발방지계획서" }],

  246: [{ title: "안전작업계획(허가)" }, { title: "안전작업계획서(고위험작업)" }],
  247: [{ title: "안전작업계획" }, { title: "안전작업계획서" }],
  248: [{ title: "안전작업계획" }, { title: "안전작업계획서" }],
  249: [{ title: "안전작업계획" }, { title: "안전작업계획서" }],
  250: [{ title: "안전보건환경 예산" }, { title: "산업안전보건관리비" }],

  251: [{ title: "안전·보건조직체계" }, { title: "현장근로자 정보" }],
  252: [{ title: "안전보건환경 예산" }, { title: "환경보전비" }],
  253: [{ title: "아차사고" }, { title: "아차사고 발생 현황" }],
  254: [{ title: "아차사고" }, { title: "아차사고 발생 현황" }],
  255: [{ title: "아차사고" }, { title: "아차사고 발생 현황" }],
  256: [{ title: "위험성평가" }, { title: "최초 위험성평가" }],
  257: [{ title: "안전작업계획(허가)" }, { title: "작업허가서" }],
  258: [{ title: "안전작업허가" }, { title: "작업허가서" }],
  259: [{ title: "안전·보건관리 현황" }, { title: "안전보건(도급)협의체" }],
  260: [{ title: "안전·보건관리 현황" }, { title: "노사협의체" }],
  261: [{ title: "안전작업계획" }, { title: "공사일보" }],
  262: [{ title: "안전·보건 점검" }, { title: "본사 안전보건 점검" }],
  263: [{ title: "안전·보건 점검" }, { title: "자율안전점검 컨설팅" }],
  264: [{ title: "안전·보건 점검" }, { title: "외부기관 안전보건 점검" }],
  265: [{ title: "안전·보건 점검" }, { title: "작업장 순회점검일지" }],
  266: [{ title: "안전·보건 점검" }, { title: "안전업무일지" }],
  267: [{ title: "안전·보건관리 현황" }, { title: "노사 합동안전보건 점검" }],
  268: [{ title: "위험성평가" }, { title: "최초 위험성평가" }],
  269: [{ title: "위험성평가" }, { title: "위험성평가회의록" }],
  270: [{ title: "위험성평가" }, { title: "정기 위험성평가" }],
  271: [{ title: "위험성평가" }, { title: "위험성평가회의록" }],
  272: [{ title: "위험성평가" }, { title: "수시 위험성평가" }],
  273: [{ title: "위험성평가" }, { title: "위험성평가회의록" }],
  274: [{ title: "안전작업허가" }, { title: "작업허가서" }],
  275: [{ title: "재해발생 보고" }, { title: "재해전통" }],
  276: [{ title: "재해발생 보고" }, { title: "사고보고서(현장)" }],
  277: [{ title: "재해발생 보고" }, { title: "사고원인 및 대책보고사(현장)" }],
  278: [{ title: "재해발생 보고" }, { title: "재해발생원인 및 재발방지계획(현장)" }],
  279: [{ title: "산업안전보건관리비" }, { title: "산업안전보건관리비 사용내역서" }],
  280: [{ title: "안전작업계획" }, { title: "안전작업계획서" }],
  281: [{ title: "브레드크럼" }, { title: "브레드크럼" }],
  282: [{ title: "안전·보건조직체계" }, { title: "안전보건관리책임자 선임" }],
  283: [{ title: "안전·보건조직체계" }, { title: "안전보건관리 책임자 지정 외" }],
  284: [{ title: "사업장 개요" }, { title: "현장대리인 안전보건 경영방침" }],
  285: [{ title: "안전·보건조직체계" }, { title: "안전보건관리(총괄)책임자 선임" }],
  현장대리인_안전보건_경영방침: [{ title: "사업장 개요" }, { title: "현장대리인 안전보건 경영방침" }],
  286: [{ title: "안전·보건관리 현황" }, { title: "안전보건(총괄)관리책임자 업무수행평가표" }],
  287: [{ title: "안전·보건관리 현황" }, { title: "관리감독자 업무수행평가표" }],
  288: [{ title: "위험성평가" }, { title: "현장순회점검일지(현업근로자 위험성평가)" }],
  289: [{ title: "안전·보건 점검" }, { title: "안전보건 순회점검표(사무실)" }],
  290: [{ title: "안전·보건 점검" }, { title: "보건 순회점검표(현장)" }],
  291: [{ title: "안전·보건 점검" }, { title: "안전 순회점검표(현장)" }],
  292: [{ title: "안전·보건 점검" }, { title: "근골격계 증상조사표(근로자)" }],
  293: [{ title: "안전·보건 점검" }, { title: "근골격계부담작업 체크리스트" }],
  294: [{ title: "의무이행사항 점검" }, { title: "의무이행사항 점검표" }],
  295: [{ title: "의무이행사항 점검" }, { title: "의무이행사항 점검표" }],
  296: [{ title: "안전점검표" }, { title: "동청사 안전점검표" }],
  2.296: [{ title: "안전·보건 점검" }, { title: "동청사 안전점검표" }],
  297: [{ title: "안전·보건조직체계" }, { title: "관리감독자 선임" }],
  298: [{ title: "안전·보건조직체계" }, { title: "관리감독자 선임" }],
  299: [{ title: "안전·보건조직체계" }, { title: "종사자 정보" }],
  300: [{ title: "신규 사업장 등록 요청" }, { title: "직영사업장" }],
  301: [{ title: "신규 사업장 등록 요청" }, { title: "도급·용역·위탁 사업장" }],
  302: [{ title: "신규 사업장 등록 요청" }, { title: "발주 사업장" }],
  303: [{ title: "신규 시설물 등록 요청" }, { title: "시설물" }],
  304: [{ title: "안전·보건조직체계" }, { title: "유관기관 비상연락망" }],
  305: [{ title: "유해·위험요인 관리" }, { title: "유해·위험요인 조사표" }],
  306: [{ title: "유해·위험요인 관리" }, { title: "유해·위험요인 조사표" }],
  307: [{ title: "재해발생 보고" }, { title: "안전사고 발생 보고서" }],
  308: [{ title: "재해발생 보고" }, { title: "재발방지 조치 보고서" }],
  309: [{ title: "안전·보건조직체계" }, { title: "안전·보건 조직 체계도" }],
  310: [{ title: "브래드크럼" }, { title: "브래드크럼" }],
  311: [{ title: "중대시민재해 안전계획" }, { title: "수탁업체 안전계획" }],
  312: [{ title: "시설물 안전 점검" }, { title: "시설물 정기 안전 점검" }],
  313: [{ title: "유해·위험요인 관리" }, { title: "[공통]유해위험요인 파악 및 보완" }],
  314: [{ title: "브래드크럼" }, { title: "브래드크럼" }],
  315: [{ title: "브래드크럼" }, { title: "브래드크럼" }],
  316: [{ title: "브래드크럼" }, { title: "브래드크럼" }],
  317: [{ title: "중대시민재해 안전계획" }, { title: "은평구 중대시민재해 종합계획" }],
  318: [{ title: "건강진단 현황" }, { title: "특수건강진단" }],
  319: [{ title: "안전·보건조직체계" }, { title: "안전보건관리체계 구축 현황(중대시민재해)" }],
  320: [{ title: "브래드크럼" }, { title: "브래드크럼" }],
  321: [{ title: "브래드크럼" }, { title: "브래드크럼" }],
  322: [{ title: "브래드크럼" }, { title: "브래드크럼" }],
  323: [{ title: "브래드크럼" }, { title: "브래드크럼" }],
  324: [{ title: "브래드크럼" }, { title: "브래드크럼" }],
  325: [{ title: "브래드크럼" }, { title: "브래드크럼" }],
  326: [{ title: "브래드크럼" }, { title: "브래드크럼" }],
  327: [{ title: "브래드크럼" }, { title: "브래드크럼" }],
  328: [{ title: "브래드크럼" }, { title: "브래드크럼" }],
  329: [{ title: "브래드크럼" }, { title: "브래드크럼" }],
  330: [{ title: "브래드크럼" }, { title: "브래드크럼" }],
  337: [{ title: "중대시민재해 안전계획" }, { title: "관련부서 안전계획" }],
  338: [{ title: "시설물 안전 인력" }, { title: "시설물 안전 인력(위탁업체)" }],
  345: [{ title: "재해발생 보고" }, { title: "중대재해 발생 보고(건설업)" }],
  346: [{ title: "재해발생 보고" }, { title: "중대재해 발생 보고(제조업)" }],

  348: [{ title: "안전보건 관리 현황" }, { title: "중대시민재해 이행사항 점검" }],
  349: [{ title: "의무이행사항 점검" }, { title: "원료·제조물 의무이행 점검" }],
  350: [{ title: "시설물 안전 점검" }, { title: "직영시설물 안전점검 이행" }],
  351: [{ title: "시설물 안전 점검" }, { title: "위탁시설물 안전종합점검 이행" }],
  352: [{ title: "유해·위험요인 관리(수시)" }, { title: "동절기 대비 시설물 등 안전점검표" }],
  353: [{ title: "유해·위험요인 관리(수시)" }, { title: "우기대비 시설물 안전점검표" }],
  354: [{ title: "유해·위험요인 관리(수시)" }, { title: "해빙기 시설물 등 안전점검표" }],

  358: [{ title: "안전·보건조직체계" }, { title: "종사자 정보" }],

  360: [{ title: "시스템 계약 현황" }, { title: "수급업체 계약정보" }],
  361: [{ title: "건강진단 현황" }, { title: "유소견자 사후관리" }],
  362: [{ title: "건강진단 현황" }, { title: "유소견자 건강 상담 실적 통계" }],
  363: [{ title: "건강진단 현황" }, { title: "사후관리 안내문" }],
  364: [{ title: "건강진단 현황" }, { title: "일정관리" }],
  365: [{ title: "건강진단 현황" }, { title: "의약품 지급 현황" }],
  366: [{ title: "건강진단 현황" }, { title: "의료기구 점검 현황" }],
  367: [{ title: "건강진단 현황" }, { title: "뇌심혈관질환 발병위험도 평가 및 사후관리 절차 개요" }],
  뇌심혈관질환_발병위험도평가및사후관리절차개요: [{ title: "건강진단 현황" }, { title: "뇌심혈관질환 발병위험도 평가 및 사후관리 절차 개요" }],
  368: [{ title: "건강진단 현황" }, { title: "뇌심혈관질환 발병위험도평가자료 종합조사표" }],
  369: [{ title: "건강진단 현황" }, { title: "뇌심혈관질환발병위험도에 따른 업무적합성 평가서" }],
  370: [{ title: "건강진단 현황" }, { title: "관련자료" }],
  372: [{ title: "유해·위험요인 관리" }, { title: "아차사고 등록" }],

  377: [{ title: "안전·보건 점검" }, { title: "TBM(작업 전 안전점검회의)" }],
  378: [{ title: "안전·보건 점검" }, { title: "TBM 실행 체크리스트" }],

  399: [{ title: "건강진단 현황" }, { title: "화학물질 관리대장" }],
  400: [{ title: "건강진단 현황" }, { title: "화학물질(작업환경측정 대상) 취급대장" }],

  436: [{ title: "안전·보건조직체계" }, { title: "유관기관 비상연락망" }],

  438: [{ title: "안전·보건 점검" }, { title: "휴게시설 주요 체크리스트" }],

  456: [{ title: "안전·보건조직체계" }, { title: "종사자 정보" }],

  478: [{ title: "안전·보건 예산" }, { title: "(공중교통수단)안전보건 예산" }],
  479: [{ title: "안전·보건 예산" }, { title: "(공중(다중)이용시설)안전보건 예산" }],
  480: [{ title: "안전·보건 확보 의무" }, { title: "(공중교통수단)안전·보건 확보 의무" }],
  481: [{ title: "안전·보건 확보 의무" }, { title: "(공중(다중)이용시설)안전·보건 확보 의무" }],
  492: [{ title: "안전보건 조직체계" }, { title: "유관기관 비상연락망" }],
};
